export * from './work-income-repeat.component';
